import generalSetting from "@/pages/settings/generalSetting.vue";
import registrationSetting from "@/pages/settings/registrationSetting.vue";
import rewardSetting from "@/pages/settings/rewardSetting.vue";
import invoiceSetting from "@/pages/settings/invoiceSetting.vue";
import BackupLogs from "@/pages/settings/BackupLogs.vue";
import statuses from '../pages/settings/report_status.vue';

const routes = [
  { // statuses
    path: 'statuses',
    name: 'statuses',
    component: statuses,
    meta:{
      name: 'Status',
      requireAuth: true
    },
    props: true
  },
  { // /reward-setting
    path: '/reward-setting',
    name: 'reward-setting',
    component: rewardSetting,
    meta:{
      name: 'Reward Setting',
      requireAuth: true
    },
  },
  { // /registration setting
    path: '/registration-setting',
    name: 'registration-setting',
    component: registrationSetting,
    meta:{
      name: 'Registration Setting',
      requireAuth: true
    },
  },
  { // /general-setting
    path: '/general-setting',
    name: 'general-setting',
    component: generalSetting,
    meta:{
      name: 'General Setting',
      requireAuth: true
    },
  },
  { // /invoice-setting
    path: '/invoice-setting',
    name: 'invoice-setting',
    component: invoiceSetting,
    meta:{
      name: 'Invoice Setting',
      requireAuth: true
    },
  },
  { // /backup-logs
    path: '/backup-logs',
    name: 'backup-logs',
    component: BackupLogs,
    meta:{
      name: 'Backup Logs',
      requireAuth: true
    },
  },
]

export default routes